import { Schema } from '@core/data/dto/schema';

export const DeliveryOrderQuoteDriverSchema = {
    id: Schema.String,
    name: Schema.String,
    active: Schema.Boolean,
    vehicle_type: Schema.Auto,
    vehicle_identifier: Schema.String,
    avatar_url: Schema.String,
    phone: Schema.String,
    order_count: Schema.Number,
};
